export const minTransactionListHeight = 544;
//# sourceMappingURL=constants.js.map